import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { usePWAContext } from "../pwa/PWAProvider";

const socket = io(
  process.env.REACT_APP_SOCKET_URL || "http://localhost:5000"
);

const useSocket = () => {
  const [monitoringData, setMonitoringData] = useState([]);
  const [connected, setConnected] = useState(false);
  const { sendNotification, isOnline } = usePWAContext();

  useEffect(() => {
    socket.on("connect", () => setConnected(true));
    socket.on("disconnect", () => setConnected(false));

    socket.on("monitoring_update", (data) => {
      setMonitoringData(data);

      // Push notification for offline devices
      const offline = data.filter((d) => d.status === "OFFLINE");
      offline.forEach((d) => {
        sendNotification(
          "⚠️ Device Offline",
          `${d.name} (${d.ipAddress}) is not responding`,
          "/alerts"
        );
      });
    });

    socket.on("anomaly_detected", (anomalies) => {
      anomalies.forEach((a) => {
        sendNotification(
          "🔍 Anomaly Detected",
          `${a.deviceName}: ${a.type.replace("_", " ")}`,
          "/anomalies"
        );
      });
    });

    return () => {
      socket.off("monitoring_update");
      socket.off("anomaly_detected");
      socket.off("connect");
      socket.off("disconnect");
    };
  }, [sendNotification]);

  return { monitoringData, connected, isOnline };
};

export default useSocket;